webpackJsonp([0],{

/***/ 153:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_th_Filter_vue__ = __webpack_require__(910);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_08052cc9_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_th_Filter_vue__ = __webpack_require__(934);
function injectStyle (ssrContext) {
  __webpack_require__(917)
}
var normalizeComponent = __webpack_require__(19)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_th_Filter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_08052cc9_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_th_Filter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 909:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);


var filterMixins = {
  data: function data() {
    return {
      keyword: '',
      isOpen: false,
      results: [],
      arrowCounter: -1
    };
  },

  props: {
    field: String,
    title: String,
    query: Object,
    items: Array,
    resetKeyword: Boolean,
    nChanges: Number,
    filterType: String
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this.$el).on('shown.bs.dropdown', function (e) {
      return _this.$refs.input.focus();
    });
    this.setOptions();
  },

  computed: {
    keywordIsSet: function keywordIsSet() {
      return !!(this.query.assocFilters[this.field] || this.query.freeTextFilters[this.field]);
    }
  },
  methods: {
    search: function search(box) {
      var query = this.query;

      if (this.filterType === 'Array') {
        this.$set(query.assocFilters, this.field, this.filterCategories);
      } else {
        this.$set(query.freeTextFilters, this.field, this.keyword);
      }
      query.offset = 0; // reset pagination
      query.filterIsActive = true;
      // this.query.offset = 0
      this.$set(this.query, 'nChanges', this.query.nChanges + 1);
      if (box) box.isOpen = false;
    },
    setResults: function setResults(result) {
      this.keyword = result;
      this.isOpen = false;
      this.search();
    },
    onChange: function onChange() {
      this.arrowCounter = -1;
    },
    onArrowDown: function onArrowDown() {
      if (this.arrowCounter < this.results.length) {
        this.arrowCounter = this.arrowCounter + 1;
      }
    },
    onArrowUp: function onArrowUp() {
      if (this.arrowCounter > 0) {
        this.arrowCounter = this.arrowCounter - 1;
      }
    },
    onEnter: function onEnter() {
      if (this.arrowCounter > -1) {
        this.keyword = this.results[this.arrowCounter];
      }
      this.isOpen = false;
      this.arrowCounter = -1;
      this.search();
    },
    deleteFilter: function deleteFilter(box) {
      this.$delete(this.query.freeTextFilters, this.field);
      this.$delete(this.query.assocFilters, this.field);
      this.$set(this.query, 'nChanges', this.query.nChanges + 1);
      if (this.boxes) this.$set(this.boxes, this.field, false);
      box.isOpen = !box.isOpen;
    }
  },
  watch: {
    query: {
      handler: function handler() {
        this.keyword = this.query.freeTextFilters[this.field] || this.query.assocFilters[this.field];
      },

      deep: true
    },
    resetKeyword: function resetKeyword(rkw) {
      if (rkw) {
        this.keyword = undefined;
      }
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = (filterMixins);

/***/ }),

/***/ 910:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__filter_mixins__ = __webpack_require__(909);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__textFilter__ = __webpack_require__(919);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CategoryFilter__ = __webpack_require__(921);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__booleanFilter__ = __webpack_require__(923);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__medicalFilter__ = __webpack_require__(925);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__dateFilter__ = __webpack_require__(927);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__numberFilter__ = __webpack_require__(929);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_clickaway__ = __webpack_require__(933);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_clickaway___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_clickaway__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__filter_mixins__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7_vue_clickaway__["mixin"]],
  props: {
    field: String,
    title: String,
    query: Object,
    items: { type: Array, default: function _default() {
        return [];
      } },
    resetKeyword: Boolean,
    nChanges: Number,
    filterType: { type: String, default: function _default() {
        return 'FreeText';
      } }
  },
  components: {
    'text-filter': __WEBPACK_IMPORTED_MODULE_1__textFilter__["a" /* default */],
    'category-filter': __WEBPACK_IMPORTED_MODULE_2__CategoryFilter__["a" /* default */],
    'bool-filter': __WEBPACK_IMPORTED_MODULE_3__booleanFilter__["a" /* default */],
    'medical-filter': __WEBPACK_IMPORTED_MODULE_4__medicalFilter__["a" /* default */],
    'date-filter': __WEBPACK_IMPORTED_MODULE_5__dateFilter__["a" /* default */],
    'number-filter': __WEBPACK_IMPORTED_MODULE_6__numberFilter__["a" /* default */]
  },
  data: function data() {
    return {
      boxes: {}
    };
  },

  methods: {
    toggleBox: function toggleBox() {
      this.$set(this.boxes, this.field, !this.boxes[this.field]);
    },
    closeBox: function closeBox() {
      this.$set(this.boxes, this.field, false);
    },
    setOptions: function setOptions() {} // to avoid error message

  }
});

/***/ }),

/***/ 911:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__filter_mixins__ = __webpack_require__(909);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'text-filter',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__filter_mixins__["a" /* default */]],
  data: function data() {
    return {
      keyword: ''
    };
  },

  methods: {
    setOptions: function setOptions() {
      var setFilter = this.query.freeTextFilters[this.field];
      this.keyword = setFilter || '';
    }
  }
});

/***/ }),

/***/ 912:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__ = __webpack_require__(518);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__filter_mixins__ = __webpack_require__(909);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_multiselect__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_multiselect__);


//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'category-filter',
  mixins: [__WEBPACK_IMPORTED_MODULE_2__filter_mixins__["a" /* default */]],
  props: {
    boxes: Object
  },
  components: {
    Multiselect: __WEBPACK_IMPORTED_MODULE_3_vue_multiselect___default.a
  },
  data: function data() {
    return {
      filterCategories: []
    };
  },

  computed: {
    searchedCategories: function searchedCategories() {
      var newCats = this.filterCategories.map(function (cat) {
        return cat.toLowerCase();
      });
      return [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default.a(this.filterCategories.concat(newCats))));
    }
  },
  methods: {
    setOptions: function setOptions() {
      var setFilter = this.query.assocFilters[this.field];
      this.filterCategories = setFilter || [];
    }
  },
  watch: {
    'query.assocFilters': {
      handler: function handler() {
        this.filterCategories = this.query.assocFilters[this.field] || [];
      }
    }
  }
});

/***/ }),

/***/ 913:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__filter_mixins__ = __webpack_require__(909);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'bool-filter',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__filter_mixins__["a" /* default */]],
  data: function data() {
    return {
      setFilter: false,
      value: false
    };
  },

  methods: {
    search: function search() {
      this.$set(this.query.freeTextFilters, this.field, this.value);
      this.query.offset = 0;
      this.$set(this.query, 'nChanges', this.query.nChanges + 1);
    },
    setOptions: function setOptions() {
      var setFilter = this.query.freeTextFilters[this.field];
      this.setFilter = setFilter;
      this.value = setFilter || false;
    }
  },
  watch: {
    'query.freeTextFilters': {
      handler: function handler() {
        this.setFilter = this.query.freeTextFilters[this.field];
      }
    },
    setFilter: function setFilter(f) {
      if (!f) {
        this.$set(this.query.freeTextFilters, this.field, undefined);
      }
    }
  }
});

/***/ }),

/***/ 914:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values__ = __webpack_require__(254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__filter_mixins__ = __webpack_require__(909);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_multiselect__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_multiselect__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'medical-filter',
  mixins: [__WEBPACK_IMPORTED_MODULE_3__filter_mixins__["a" /* default */]],
  data: function data() {
    return {
      chosenOptions: {},
      allOptions: {}
    };
  },

  props: {
    boxes: Object
  },
  components: {
    Multiselect: __WEBPACK_IMPORTED_MODULE_5_vue_multiselect___default.a
  },
  created: function created() {
    this.getFilterOptions();
  },

  methods: {
    search: function search() {
      var query = this.query;

      if (!__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default()(this.chosenOptions).length) {
        this.$set(query.assocFilters, 'medication', undefined);
      } else {
        this.$set(query.assocFilters, 'medication', this.chosenOptions);
      }
      this.$set(this.query, 'nChanges', this.query.nChanges + 1);
      this.query.offset = 0;
      this.$set(this.boxes, this.field, false);
    },
    getFilterOptions: function getFilterOptions() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var options;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].getMedicalFilterOptions();

              case 2:
                options = _context.sent;

                _this.allOptions = options;

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    setOptions: function setOptions() {
      var _this2 = this;

      var setFilters = this.query.assocFilters.medication;
      var possibleFilters = ['option', 'substance', 'moa', 'effect'];
      possibleFilters.forEach(function (fil) {
        _this2[fil] = setFilters && setFilters[fil] ? setFilters[fil] : '';
      });
    },
    deleteMedicalFilter: function deleteMedicalFilter(boxes) {
      this.chosenOptions = {};
      this.deleteFilter(boxes);
    }
  },
  watch: {
    'query.assocFilters': {
      handler: function handler() {
        this.chosenOptions = this.query.assocFilters.medication || {};
      }
    }
  }
});

/***/ }),

/***/ 915:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__filter_mixins__ = __webpack_require__(909);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuejs_datepicker__ = __webpack_require__(519);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuejs_datepicker_dist_locale__ = __webpack_require__(520);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuejs_datepicker_dist_locale___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuejs_datepicker_dist_locale__);

//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'date-filter',
  mixins: [__WEBPACK_IMPORTED_MODULE_1__filter_mixins__["a" /* default */]],
  components: {
    Datepicker: __WEBPACK_IMPORTED_MODULE_2_vuejs_datepicker__["a" /* default */]
  },
  data: function data() {
    return {
      dateFilter: {},
      de: __WEBPACK_IMPORTED_MODULE_3_vuejs_datepicker_dist_locale__["de"]
    };
  },

  methods: {
    search: function search() {
      console.log(this.dateFilter, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(this.dateFilter.gte));
      this.$set(this.query.freeTextFilters, this.field, this.dateFilter);
      this.query.offset = 0;
      this.$set(this.query, 'nChanges', this.query.nChanges + 1);
    },
    setOptions: function setOptions() {
      var setFilter = this.query.freeTextFilters[this.field];
      this.dateFilter = setFilter || {};
    }
  },
  watch: {
    'query.freeTextFilters': {
      handler: function handler() {
        this.dateFilter = this.query.freeTextFilters[this.field] || {};
      }
    }
  }
});

/***/ }),

/***/ 916:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__filter_mixins__ = __webpack_require__(909);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'number-filter',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__filter_mixins__["a" /* default */]],
  data: function data() {
    return {
      numberFilter: {}
    };
  },

  methods: {
    search: function search() {
      if (['age', 'day_nr'].includes(this.field)) {
        if (this.numberFilter.gte) this.numberFilter.gte = Math.round(this.numberFilter.gte.replace(',', '.'));
        if (this.numberFilter.lte) this.numberFilter.lte = Math.round(this.numberFilter.lte.replace(',', '.'));
      }
      this.$set(this.query.freeTextFilters, this.field, this.numberFilter);
      this.query.offset = 0;
      this.$set(this.query, 'nChanges', this.query.nChanges + 1);
    },
    setOptions: function setOptions() {
      var setFilter = this.query.freeTextFilters[this.field];
      this.numberFilter = setFilter || {};
    }
  },
  watch: {
    'query.freeTextFilters': {
      handler: function handler() {
        this.numberFilter = this.query.freeTextFilters[this.field] || {};
      }
    }
  }
});

/***/ }),

/***/ 917:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(918);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(908)("d76ab20a", content, true, {});

/***/ }),

/***/ 918:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(907)(true);
// imports


// module
exports.push([module.i, ".dropdown-is-open{display:block!important}input[type=search]::-webkit-search-cancel-button{-webkit-appearance:searchfield-cancel-button;cursor:pointer}.search-box{z-index:1}.medication-group{margin-bottom:5px}.open>.dropdown-menu{display:block;opacity:1;visibility:visible;width:210px}.search-input-field{cursor:text;height:30px!important}.search-button{height:30px;width:37px;padding:0 10px 5px}.autocomplete{position:relative;width:130px}.autocomplete-results{padding:0;margin:0;border:1px solid #000;overflow:auto}.autocomplete-result{list-style:none;text-align:left;padding:4px 2px;cursor:pointer;background-color:#dcdcdc}.autocomplete-result.is-active,.autocomplete-result:hover{background-color:#4aae9b;color:#fff}", "", {"version":3,"sources":["/home/nweibrecht/Dokumente/Akribes/Akribes-App/src/components/plugins/th-Filter.vue"],"names":[],"mappings":"AACA,kBACE,uBAA0B,CAC3B,AACD,iDACE,6CAA8C,AAC9C,cAAgB,CACjB,AACD,YACE,SAAW,CACZ,AACD,kBACE,iBAAmB,CACpB,AACD,qBACE,cAAe,AACf,UAAW,AACX,mBAAoB,AACpB,WAAa,CACd,AACD,oBACE,YAAa,AACb,qBAAwB,CACzB,AACD,eACE,YAAa,AACb,WAAY,AACZ,kBAAmB,CAIpB,AACD,cACI,kBAAmB,AACnB,WAAa,CAChB,AACD,sBACI,UAAW,AACX,SAAU,AACV,sBAAwB,AAExB,aAAe,CAClB,AACD,qBACI,gBAAiB,AACjB,gBAAiB,AACjB,gBAAiB,AACjB,eAAgB,AAChB,wBAA4B,CAC/B,AACD,0DAEI,yBAA0B,AAC1B,UAAa,CAChB","file":"th-Filter.vue","sourcesContent":["\n.dropdown-is-open {\n  display: block !important;\n}\ninput[type=search]::-webkit-search-cancel-button {\n  -webkit-appearance: searchfield-cancel-button;\n  cursor: pointer;\n}\n.search-box {\n  z-index: 1;\n}\n.medication-group {\n  margin-bottom: 5px;\n}\n.open>.dropdown-menu {\n  display: block;\n  opacity: 1;\n  visibility: visible;\n  width: 210px;\n}\n.search-input-field {\n  cursor: text;\n  height: 30px !important;\n}\n.search-button {\n  height: 30px;\n  width: 37px;\n  padding-left: 10px;\n  padding-top: 0px;\n  padding-right: 10px;\n  padding-bottom: 5px;\n}\n.autocomplete {\n    position: relative;\n    width: 130px;\n}\n.autocomplete-results {\n    padding: 0;\n    margin: 0;\n    border: 1px solid black;\n    /*height: 120px;*/\n    overflow: auto;\n}\n.autocomplete-result {\n    list-style: none;\n    text-align: left;\n    padding: 4px 2px;\n    cursor: pointer;\n    background-color: gainsboro;\n}\n.autocomplete-result.is-active,\n.autocomplete-result:hover {\n    background-color: #4AAE9B;\n    color: white;\n}\n\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 919:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_textFilter_vue__ = __webpack_require__(911);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_50b04d45_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_textFilter_vue__ = __webpack_require__(920);
var normalizeComponent = __webpack_require__(19)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_textFilter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_50b04d45_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_textFilter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 920:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"input-group input-group-sm"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.keyword),expression:"keyword"}],ref:"input",staticClass:"form-control search-input-field",attrs:{"type":"search","placeholder":(_vm.title + " filtern ...")},domProps:{"value":(_vm.keyword)},on:{"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.onEnter.apply(null, arguments)},"input":[function($event){if($event.target.composing){ return; }_vm.keyword=$event.target.value},_vm.onChange],"keyup":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"down",40,$event.key,["Down","ArrowDown"])){ return null; }return _vm.onArrowDown.apply(null, arguments)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"up",38,$event.key,["Up","ArrowUp"])){ return null; }return _vm.onArrowUp.apply(null, arguments)}]}}),_vm._v(" "),_c('ul',{directives:[{name:"show",rawName:"v-show",value:(_vm.isOpen),expression:"isOpen"}],staticClass:"autocomplete-results"},_vm._l((_vm.results),function(result,i){return _c('li',{key:i,staticClass:"autocomplete-result",class:{ 'is-active': i === _vm.arrowCounter },on:{"click":function($event){return _vm.setResults(result)}}},[_vm._v(" "+_vm._s(result)+"\n      ")])}),0)]),_vm._v(" "),_c('b-btn',{staticClass:"btn btn-sm btn-block",staticStyle:{"margin-top":"2px"},on:{"click":_vm.search}},[_vm._v(" Anwenden ")]),_vm._v(" "),_c('b-btn',{staticClass:"btn btn-sm btn-block",staticStyle:{"margin-top":"2px"},on:{"click":_vm.deleteFilter}},[_vm._v(" Filter zurücksetzen ")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 921:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CategoryFilter_vue__ = __webpack_require__(912);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f5a1d21c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CategoryFilter_vue__ = __webpack_require__(922);
var normalizeComponent = __webpack_require__(19)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CategoryFilter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f5a1d21c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CategoryFilter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 922:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"input-group input-group-sm"},[_c('multiselect',{attrs:{"placeholder":(_vm.title + " filtern ..."),"options":_vm.items,"multiple":true},model:{value:(_vm.filterCategories),callback:function ($$v) {_vm.filterCategories=$$v},expression:"filterCategories"}})],1),_vm._v(" "),_c('b-btn',{staticClass:"btn btn-sm btn-block",staticStyle:{"margin-top":"2px"},on:{"click":function($event){return _vm.search(_vm.boxes)}}},[_vm._v(" Anwenden ")]),_vm._v(" "),_c('b-btn',{staticClass:"btn btn-sm btn-block",staticStyle:{"margin-top":"2px"},on:{"click":function($event){return _vm.deleteFilter(_vm.boxes)}}},[_vm._v(" Filter zurücksetzen ")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 923:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_booleanFilter_vue__ = __webpack_require__(913);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6d01bed0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_booleanFilter_vue__ = __webpack_require__(924);
var normalizeComponent = __webpack_require__(19)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_booleanFilter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6d01bed0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_booleanFilter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 924:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"padding":"5px"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.setFilter),expression:"setFilter"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.setFilter)?_vm._i(_vm.setFilter,null)>-1:(_vm.setFilter)},on:{"change":function($event){var $$a=_vm.setFilter,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.setFilter=$$a.concat([$$v]))}else{$$i>-1&&(_vm.setFilter=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.setFilter=$$c}}}}),_vm._v(" "),_c('label',{staticStyle:{"font-weight":"normal","text-transform":"none"}},[_vm._v(" "+_vm._s((_vm.setFilter) ? 'Filter:' : 'Kein Filter gesetzt')+" ")]),_vm._v(" "),(_vm.setFilter)?_c('div',[_c('label',{staticStyle:{"font-weight":"normal","text-transform":"none"}},[_vm._v(" \n      "+_vm._s(_vm.title)+": "),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.value),expression:"value"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.value)?_vm._i(_vm.value,null)>-1:(_vm.value)},on:{"change":function($event){var $$a=_vm.value,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.value=$$a.concat([$$v]))}else{$$i>-1&&(_vm.value=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.value=$$c}}}}),_vm._v("\n      "+_vm._s((_vm.value) ? 'Ja' : 'Nein')+" \n    ")]),_vm._v(" "),_c('b-btn',{staticClass:"btn btn-sm btn-block",on:{"click":_vm.search}},[_vm._v(" Anwenden ")])],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 925:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_medicalFilter_vue__ = __webpack_require__(914);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d80b922_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_medicalFilter_vue__ = __webpack_require__(926);
var normalizeComponent = __webpack_require__(19)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_medicalFilter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d80b922_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_medicalFilter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 926:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"input-group input-group-sm medication-group"},[(_vm.allOptions.medication)?_c('multiselect',{attrs:{"placeholder":'Medikamente filtern ...',"options":_vm.allOptions.medication,"multiple":true},model:{value:(_vm.chosenOptions.option),callback:function ($$v) {_vm.$set(_vm.chosenOptions, "option", $$v)},expression:"chosenOptions.option"}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"input-group input-group-sm medication-group"},[(_vm.allOptions.substance)?_c('multiselect',{attrs:{"placeholder":'Wirkstoffe filtern ...',"options":_vm.allOptions.substance,"multiple":true},model:{value:(_vm.chosenOptions.substance),callback:function ($$v) {_vm.$set(_vm.chosenOptions, "substance", $$v)},expression:"chosenOptions.substance"}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"input-group input-group-sm medication-group"},[(_vm.allOptions.moa)?_c('multiselect',{attrs:{"placeholder":'MoAs filtern ...',"options":_vm.allOptions.moa,"multiple":true},model:{value:(_vm.chosenOptions.moa),callback:function ($$v) {_vm.$set(_vm.chosenOptions, "moa", $$v)},expression:"chosenOptions.moa"}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"input-group input-group-sm medication-group"},[(_vm.allOptions.effect)?_c('multiselect',{attrs:{"placeholder":'Effekte filtern ...',"options":_vm.allOptions.effect,"multiple":true},model:{value:(_vm.chosenOptions.effect),callback:function ($$v) {_vm.$set(_vm.chosenOptions, "effect", $$v)},expression:"chosenOptions.effect"}}):_vm._e()],1),_vm._v(" "),_c('b-btn',{staticClass:"btn btn-sm btn-block",on:{"click":function($event){return _vm.search(_vm.boxes)}}},[_vm._v(" Anwenden ")]),_vm._v(" "),_c('b-btn',{staticClass:"btn btn-sm btn-block",staticStyle:{"margin-top":"2px"},on:{"click":function($event){return _vm.deleteMedicalFilter(_vm.boxes)}}},[_vm._v(" Filter zurücksetzen ")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 927:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_dateFilter_vue__ = __webpack_require__(915);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a73cf2a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_dateFilter_vue__ = __webpack_require__(928);
var normalizeComponent = __webpack_require__(19)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_dateFilter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a73cf2a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_dateFilter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 928:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"padding":"5px"}},[_c('datepicker',{staticStyle:{"margin-bottom":"3px"},attrs:{"placeholder":"Von","language":_vm.de,"bootstrap-styling":true},model:{value:(_vm.dateFilter.gte),callback:function ($$v) {_vm.$set(_vm.dateFilter, "gte", $$v)},expression:"dateFilter.gte"}}),_vm._v(" "),_c('datepicker',{staticStyle:{"margin-bottom":"3px"},attrs:{"placeholder":"Bis","language":_vm.de,"bootstrap-styling":true},model:{value:(_vm.dateFilter.lte),callback:function ($$v) {_vm.$set(_vm.dateFilter, "lte", $$v)},expression:"dateFilter.lte"}}),_vm._v(" "),_c('b-btn',{staticClass:"btn btn-sm btn-block",on:{"click":_vm.search}},[_vm._v(" Anwenden ")]),_vm._v(" "),_c('b-btn',{staticClass:"btn btn-sm btn-block",on:{"click":_vm.deleteFilter}},[_vm._v(" Filter zurücksetzen ")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 929:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_numberFilter_vue__ = __webpack_require__(916);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f1ac3694_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_numberFilter_vue__ = __webpack_require__(932);
function injectStyle (ssrContext) {
  __webpack_require__(930)
}
var normalizeComponent = __webpack_require__(19)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_numberFilter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f1ac3694_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_numberFilter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 930:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(931);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(908)("5dcdcbcc", content, true, {});

/***/ }),

/***/ 931:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(907)(true);
// imports


// module
exports.push([module.i, ".number-filter{margin-bottom:3px}", "", {"version":3,"sources":["/home/nweibrecht/Dokumente/Akribes/Akribes-App/src/components/plugins/numberFilter.vue"],"names":[],"mappings":"AACA,eACE,iBAAmB,CACpB","file":"numberFilter.vue","sourcesContent":["\n.number-filter {\n  margin-bottom: 3px;\n}\n\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 932:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"padding":"5px"}},[_c('label',{staticStyle:{"font-weight":"normal","text-transform":"none"}},[_vm._v(" "+_vm._s(_vm.title)+" filtern ")]),_vm._v(" "),_c('div',{staticStyle:{"display":"inline-flex"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.numberFilter.gte),expression:"numberFilter.gte"}],ref:"input",staticClass:"col-md-5 number-filter form-control search-input-field",attrs:{"type":"search","placeholder":'Von'},domProps:{"value":(_vm.numberFilter.gte)},on:{"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.onEnter.apply(null, arguments)},"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.numberFilter, "gte", $event.target.value)},_vm.onChange],"keyup":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"down",40,$event.key,["Down","ArrowDown"])){ return null; }return _vm.onArrowDown.apply(null, arguments)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"up",38,$event.key,["Up","ArrowUp"])){ return null; }return _vm.onArrowUp.apply(null, arguments)}]}}),_vm._v(" "),_c('center',{staticClass:"col-md-2",staticStyle:{"font-weight":"normal"}},[_vm._v("  -  ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.numberFilter.lte),expression:"numberFilter.lte"}],ref:"input",staticClass:"col-md-5 form-control search-input-field",attrs:{"type":"search","placeholder":'Bis'},domProps:{"value":(_vm.numberFilter.lte)},on:{"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.onEnter.apply(null, arguments)},"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.numberFilter, "lte", $event.target.value)},_vm.onChange],"keyup":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"down",40,$event.key,["Down","ArrowDown"])){ return null; }return _vm.onArrowDown.apply(null, arguments)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"up",38,$event.key,["Up","ArrowUp"])){ return null; }return _vm.onArrowUp.apply(null, arguments)}]}})],1),_vm._v(" "),_c('b-btn',{staticClass:"btn btn-sm btn-block",on:{"click":_vm.search}},[_vm._v(" Anwenden ")]),_vm._v(" "),_c('b-btn',{staticClass:"btn btn-sm btn-block",on:{"click":_vm.deleteFilter}},[_vm._v(" Filter zurücksetzen ")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 933:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Vue = __webpack_require__(78);
Vue = 'default' in Vue ? Vue['default'] : Vue;

var version = '2.2.2';

var compatible = (/^2\./).test(Vue.version);
if (!compatible) {
  Vue.util.warn('VueClickaway ' + version + ' only supports Vue 2.x, and does not support Vue ' + Vue.version);
}



// @SECTION: implementation

var HANDLER = '_vue_clickaway_handler';

function bind(el, binding, vnode) {
  unbind(el);

  var vm = vnode.context;

  var callback = binding.value;
  if (typeof callback !== 'function') {
    if (false) {
      Vue.util.warn(
        'v-' + binding.name + '="' +
        binding.expression + '" expects a function value, ' +
        'got ' + callback
      );
    }
    return;
  }

  // @NOTE: Vue binds directives in microtasks, while UI events are dispatched
  //        in macrotasks. This causes the listener to be set up before
  //        the "origin" click event (the event that lead to the binding of
  //        the directive) arrives at the document root. To work around that,
  //        we ignore events until the end of the "initial" macrotask.
  // @REFERENCE: https://jakearchibald.com/2015/tasks-microtasks-queues-and-schedules/
  // @REFERENCE: https://github.com/simplesmiler/vue-clickaway/issues/8
  var initialMacrotaskEnded = false;
  setTimeout(function() {
    initialMacrotaskEnded = true;
  }, 0);

  el[HANDLER] = function(ev) {
    // @NOTE: this test used to be just `el.containts`, but working with path is better,
    //        because it tests whether the element was there at the time of
    //        the click, not whether it is there now, that the event has arrived
    //        to the top.
    // @NOTE: `.path` is non-standard, the standard way is `.composedPath()`
    var path = ev.path || (ev.composedPath ? ev.composedPath() : undefined);
    if (initialMacrotaskEnded && (path ? path.indexOf(el) < 0 : !el.contains(ev.target))) {
      return callback.call(vm, ev);
    }
  };

  document.documentElement.addEventListener('click', el[HANDLER], false);
}

function unbind(el) {
  document.documentElement.removeEventListener('click', el[HANDLER], false);
  delete el[HANDLER];
}

var directive = {
  bind: bind,
  update: function(el, binding) {
    if (binding.value === binding.oldValue) return;
    bind(el, binding);
  },
  unbind: unbind,
};

var mixin = {
  directives: { onClickaway: directive },
};

exports.version = version;
exports.directive = directive;
exports.mixin = mixin;

/***/ }),

/***/ 934:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"on-clickaway",rawName:"v-on-clickaway",value:(_vm.closeBox),expression:"closeBox"}],staticClass:"btn-group"},[_c('a',{attrs:{"href":"javascript:;","data-toggle":"dropdown"},on:{"click":_vm.toggleBox}},[_c('i',{staticClass:"fa fa-filter",class:{ 'text-muted': !_vm.keywordIsSet, 'activeOption': _vm.keywordIsSet}})]),_vm._v(" "),(_vm.title === 'Medikamente')?_c('ul',{staticClass:"dropdown-menu",staticStyle:{"padding":"5px","min-width":"280px"},style:({ display: (_vm.boxes[_vm.field]) ? 'block' : 'none' })},[_c('medical-filter',_vm._b({attrs:{"boxes":_vm.boxes}},'medical-filter',_vm.$props,false))],1):(_vm.filterType === 'Boolean')?_c('ul',{staticClass:"dropdown-menu",staticStyle:{"padding":"3px"}},[_c('bool-filter',_vm._b({},'bool-filter',_vm.$props,false))],1):(_vm.filterType.includes('Date'))?_c('ul',{staticClass:"dropdown-menu",staticStyle:{"padding":"3px","min-width":"210px"},style:({ display: (_vm.boxes[_vm.field]) ? 'block' : 'none' })},[_c('date-filter',_vm._b({},'date-filter',_vm.$props,false))],1):(_vm.filterType.includes('Number'))?_c('ul',{staticClass:"dropdown-menu",staticStyle:{"padding":"3px"}},[_c('number-filter',_vm._b({},'number-filter',_vm.$props,false))],1):(_vm.filterType === 'Array')?_c('ul',{staticClass:"dropdown-menu",staticStyle:{"padding":"3px","min-width":"280px"},style:({ display: (_vm.boxes[_vm.field]) ? 'block' : 'none' })},[_c('category-filter',_vm._b({attrs:{"boxes":_vm.boxes}},'category-filter',_vm.$props,false))],1):_c('ul',{staticClass:"dropdown-menu",staticStyle:{"padding":"3px"}},[_c('text-filter',_vm._b({},'text-filter',_vm.$props,false))],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/0.ad515653d6f347e9d8ef.js